/* AMC heading rules. Keep source statistics stable during page startup. */
(() => {
  const rule = () => {
    const headings = [];
    document.querySelectorAll('#MainContent .shopify-section h2').forEach(h => {
      if (h.classList.contains('amc-rule') || h.closest('.amc-opening-hero,.card,.card-wrapper,[class*="card"],details,.amc-ft,.amc-kl__article,.rte')) return;
      const text = h.textContent.trim();
      if (!text || text.length > 42) return;
      const style = getComputedStyle(h);
      if (parseFloat(style.fontSize) >= 20) headings.push([h, style.textAlign === 'center']);
    });
    headings.forEach(([h, centered]) => {
      h.classList.add('amc-rule');
      if (centered) h.classList.add('amc-rule--center');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rule, { once:true });
  else rule();
  document.addEventListener('shopify:section:load', rule);
})();
